import gql from "graphql-tag";
const getAllDepartment = gql`
  query(
    $status: String
    $limit: Int
    $page: Int
    $query: String
    $workShiftIds: [ID!]
  ) {
    getAllDepartment(
      status: $status
      query: $query
      paging: { limit: $limit, page: $page }
      filter: { workShiftIds: $workShiftIds }
    ) {
      id
      name
      updatedAt
      createdAt
      status
    }
  }
`;

export default { getAllDepartment };
